import { Injectable } from '@angular/core';
import { Actions, concatLatestFrom, createEffect, ofType } from '@ngrx/effects';
import { filter, of, switchMap } from 'rxjs';
import { NotificationActions } from './notification.actions';
import { ROUTER_NAVIGATED } from '@ngrx/router-store';
import { NavigationUtilsActions, selectQueryParam, selectQueryParams } from '../router';
import { ApplicationQueryParamsEnum, PaymentStatusEnum } from '@modules/core/enums';
import { Store } from '@ngrx/store';

@Injectable()
export class NotificationEffects {
  constructor(private actions$: Actions, private store: Store) {}

  afterInitNotification$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(NotificationActions.addError, NotificationActions.addSuccess),
      concatLatestFrom(() => [this.store.select(selectQueryParams)]),
      /* eslint-disable @typescript-eslint/no-unused-vars */
      switchMap(([action, params]) => {
        if (ApplicationQueryParamsEnum.PAYMENT_STATUS in params) {
          return of(NavigationUtilsActions.clearPaymentStatusURL());
        }
        return of();
      })
    );
  });

  /* eslint-disable @typescript-eslint/no-unused-vars */
  showPaymentStatus$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ROUTER_NAVIGATED),
      concatLatestFrom(() => [this.store.select(selectQueryParam(ApplicationQueryParamsEnum.PAYMENT_STATUS))]),
      filter(([action, paymentStatus]) => !!paymentStatus),
      switchMap(([action, paymentStatus]) => {
        if (paymentStatus === PaymentStatusEnum.SUCCESS) {
          return of(NotificationActions.addSuccess({ messageKey: 'common.paymentStatus.successMessage' }));
        }

        return of(NotificationActions.addError({ messageKey: 'common.paymentStatus.failureMessage' }));
      })
    );
  });
}
